/**
 * WebSocket 上行消息 type 常量（发往服务端）。
 * @module utils/realtime/wsMessageType
 */

/**
 * @typedef {typeof WS_MESSAGE_TYPE.common} WsMessageTypeCommon
 * @typedef {typeof WS_MESSAGE_TYPE.stock} WsMessageTypeStock
 */

/** 按业务域分组的 WS 消息 type */
export const WS_MESSAGE_TYPE = Object.freeze({
  common: Object.freeze({}),
  stock: Object.freeze({
    /** 个股列表秒级行情订阅 / 下行 businessType */
    STOCK_LIST_PUSH: 'stock_list_push',
    /** K 线最后一根实时推送订阅 / 下行 businessType */
    STOCK_KLINE: 'stock_kline',
    /**
     * 个股详情页头部盘口数据订阅 / 下行 businessType。
     * 承载盘口/估值 28+ 字段（含总市值/市盈TTM/市净率），字段命名与个股详情接口一致，channel 侧透传即可。
     * 注：顶部现价/涨跌幅不在此通道，走 stock_list_push。
     */
    STOCK_HEADER_DETAIL: 'stock_header_detail'
  })
});
